import React from 'react';
import { FiAlertCircle, FiArchive, FiCheckCircle, FiClock, FiPauseCircle, FiRadio } from 'react-icons/fi';

const STATUS_META = {
  Draft: { bg: '#F1F5F9', color: '#475569', borderColor: '#CBD5E1', icon: FiClock, label: 'Draft' },
  Ready: { bg: '#E0F2FE', color: '#0369A1', borderColor: '#7DD3FC', icon: FiCheckCircle, label: 'Ready' },
  Published: { bg: '#D1FAE5', color: '#047857', borderColor: '#6EE7B7', icon: FiRadio, label: 'Published' },
  Paused: { bg: '#FEF3C7', color: '#B45309', borderColor: '#FCD34D', icon: FiPauseCircle, label: 'Paused' },
  Archived: { bg: '#F4F4F5', color: '#52525B', borderColor: '#D4D4D8', icon: FiArchive, label: 'Archived' },
  Error: { bg: '#FFE4E6', color: '#BE123C', borderColor: '#FDA4AF', icon: FiAlertCircle, label: 'Error' },
};

const StatusChip = ({ status = 'Draft' }) => {
  const meta = STATUS_META[status] || STATUS_META.Draft;
  const Icon = meta.icon;

  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[10px] font-medium uppercase leading-none tracking-wide"
      style={{
        backgroundColor: meta.bg,
        color: meta.color,
        borderColor: meta.borderColor,
      }}
    >
      <Icon className="h-3 w-3 shrink-0" aria-hidden />
      {meta.label}
    </span>
  );
};

export default StatusChip;
